const massWithAbdoSite = [


    {
    label:"Size (cm)",
    controlType:"text",
    options:[]
    },

    { 
    label:"Involving",
    controlType:"checkbox group",
    options:["Right Upper Quadrant", "Left upper Quadrant", "Right Flank", "Left Flank", "Central", "Right lower Quadrant", "Left Lower Quadrant", "SupraPubic"]
    },
    
    { 
    label:"Consistency:",
    controlType:"radio button",
    options:["Hard", "Soft"]
    },

    { 
    label:"Shape:",
    controlType:"radio button",
    options:["Smooth", "Irregular"]
    },

    { 
    label:"Pain:",
    controlType:"radio button",
    options:["Painful", "Painless"]
    },

    { 
    label:"Tenderness:",
    controlType:"radio button",
    options:["Tender", "Non-tender"]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
    

]


export default massWithAbdoSite